export const updateWpm = (wpm) => {
    return{type: 'UPDATE_WPM', payload: wpm}
}